import { render, staticRenderFns } from "./ChangeDiscount.vue?vue&type=template&id=13623d1a&"
import script from "./ChangeDiscount.vue?vue&type=script&lang=js&"
export * from "./ChangeDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports